import AmplifyButton from '@amplify/amplify-button';
import clsx from 'clsx';
import { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'src/components/tooltip';
import authService from 'src/services/api/auth.service';

import './assignment-switch.scss';

type IconName = 'icon-k5-checkmark' | 'icon-k5-close';

export type AssignmentSwitchProps = {
  onClick: (e: SyntheticEvent) => void;
  onContextMenu: (e: SyntheticEvent) => void;
  isChecked: boolean;
  isAnimationInProgress?: boolean;
  iconName?: IconName;
};

const AssignmentSwitch: FC<AssignmentSwitchProps> = ({
  onClick,
  onContextMenu,
  isChecked,
  isAnimationInProgress,
  iconName = 'icon-k5-checkmark',
}) => {
  const { t } = useTranslation();
  const isTeacher = authService.isTeacher();

  const getTooltipTitle = () => {
    if (isTeacher) return t('Available for student users only');

    return isChecked ? t('Unmark') : t('Mark as Done');
  };

  const tooltipTitle = getTooltipTitle();

  return (
    <div
      className={clsx('assignment-switch', {
        'assignment-switch--hidden': isAnimationInProgress,
        'assignment-switch--checked': isChecked,
      })}
      data-testid="assignment-switch"
    >
      <Tooltip
        title={tooltipTitle}
        classNames={{
          tooltip: clsx('mark-tooltip', {
            'mark-tooltip--teacher': isTeacher,
          }),
        }}
      >
        <div className="theme-k5 layout-context-delta">
          <AmplifyButton
            variant="secondary"
            className="btn-raised btn-icon"
            icon={iconName}
            onClick={onClick}
            disabled={isTeacher}
            aria-disabled={isTeacher}
            oval
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default AssignmentSwitch;
